module.exports = __webpack_public_path__ + "img/portal-samp-single-file.1e096410.jpg";